import {
  SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST,
  SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS,
  SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE,
  DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST,
  DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS,
  DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE,
  DETAIL_PARTNER_GENERAL_CONFIG_REQUEST,
  DETAIL_PARTNER_GENERAL_CONFIG_SUCCESS,
  DETAIL_PARTNER_GENERAL_CONFIG_FAILURE
} from '../../constants/mcu-project-configuration-bmi-criteria'

const initialState = {
  loading: false,
  mcuProjectConfigurationBMICriteria: {},
  partnerGeneralConfig: {}
}

export default function mcuProjectConfigurationBMICriteria(
  state = initialState,
  action
) {
  switch (action.type) {
    case SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST:
      return {
        ...state,
        loading: true,
        loadingUpdate: true
      }
    case SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingUpdate: false
      }
    case SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE:
      return {
        ...state,
        loading: false,
        loadingUpdate: false,
        error: action.payload
      }
    case DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST:
      return {
        ...state,
        loading: true,
        loadingDetail: true
      }
    case DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingDetail: false,
        mcuProjectConfigurationBMICriteria: action.payload
      }
    case DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE:
      return {
        ...state,
        loading: false,
        loadingDetail: false,
        error: action.payload,
        mcuProjectConfigurationBMICriteria: action?.dummy
      }
    case DETAIL_PARTNER_GENERAL_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        loadingDetail: true
      }
    case DETAIL_PARTNER_GENERAL_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingDetail: false,
        partnerGeneralConfig: action.payload
      }
    case DETAIL_PARTNER_GENERAL_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        loadingDetail: false,
        error: action.payload,
        partnerGeneralConfig: action?.dummy
      }
    default:
      return state
  }
}
